import React from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'

class TableSelectInput extends React.Component {
    state = {
    }




    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    getLabel(key) {

        let fields = this.props.header?.information?.viewFields ?? this.props.header?.information?.fields
        switch (key) {
            case 'title':
                if (this.props.data) {
                    if (typeof this.props.data == 'object') {

                        return getObject(this.props.data, fields?.title)
                    } else {
                        if (this.props.header?.information?.items?.length) {
                            for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                                const item = this.props.header?.information?.items[i];
                                if (item.value == this.props.data) {
                                    return item[key]
                                }
                            }
                        }
                    }
                } else {
                    if (this.props.header?.information?.default) {
                        for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                            const item = this.props.header?.information?.items[i];
                            if (item.value == this.props.header?.information?.default) {
                                return item[key]
                            }
                        }
                    } else {
                        return ' '
                    }
                }
                break;
            case 'color': {

                let color = ''
                if (!this.props.header?.information?.type || this.props.header?.information?.type == 'local') {
                    let value = typeof this.props.data == 'object' ? getObject(this.props.data, fields?.value) : this.props.data
                    this.props.header?.information?.items?.map((element) => {
                        // console.log("value",value,element.value)

                        if (value == element.value) {
                            color = element.color
                        }
                    })

                }
                return color ?? ''
            }

            case 'background': {

                let background = ''
                if (!this.props.header?.information?.type || this.props.header?.information?.type != 'local') {
                    let value = typeof this.props.data == 'object' ? getObject(this.props.data, fields?.value) : this.props.data
                    this.props.header?.information?.items?.map((element) => {
                        if (value == element.value) {
                            background = element.background
                        }
                    })

                }
                return background ?? ''
            }
            default:
                break;
        }

    }

    render() {
        return (
            <div className="w-100 h-100 flexc">
                <p className="px-2 " style={{ color: this.getLabel("color") ? this.getLabel("color") : '', backgroundColor: this.getLabel("background"), textOverflow: 'ellipsis', overflow: 'hidden' , borderRadius: 6}}>{checkTranslation(this.getLabel("title"))}</p>
            </div>
        )
    }
}

export default TableSelectInput;